import { FC, useState } from 'react'
import { Draft, DraftRequestReviewStatus } from './types/types'
import Status from './Status'
import ActionsMenu from './ActionsMenu'
import ReviewsSection from './ReviewsSection'
import AddCommentModal from './Modals/ConfirmationModal/AddCommentModal'
import styles from './Card.module.scss'
import { getDateTimeString } from 'lib/helpers/dateHelper'
import { getChainName } from 'lib/helpers/chainHelper'
import DistributionInfo from './DistributionInfo'

import { ReactComponent as IconComment } from 'images/icons/annotation.svg'

const consoleUrl = process.env.REACT_APP_CONSOLE_URL || 'https://console.poap.xyz'

interface CardProps {
  draft: Draft
}

const Card: FC<CardProps> = ({ draft }) => {
  const [showAddCommentModal, setShowAddCommentModal] = useState(false)
  const showAddCommentButton = draft.status !== DraftRequestReviewStatus.PENDING

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img src={draft.data.cropImage.url || draft.data.image.url} alt={draft.data.title} className={styles.image} />
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <a
            href={`${consoleUrl}/drafts/${draft.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.titleLink}
            title="View in Console"
          >
            <h3 className={styles.title}>{draft.data.title}</h3>
          </a>
          <div className={styles.statusContainer}>
            <Status status={draft.status} />
            {showAddCommentButton && (
              <button
                type="button"
                className={styles.commentButton}
                onClick={() => setShowAddCommentModal(true)}
                title="Add comment"
              >
                <IconComment width={14} height={14} />
              </button>
            )}
          </div>
        </div>
        <div className={styles.metadata}>
          {draft.issuerEmail && (
            <span>
              <strong>Issuer Email:</strong> {draft.issuerEmail}
            </span>
          )}
          <span>
            <strong>Created:</strong> {getDateTimeString(new Date(draft.createdAt))}
          </span>
          <span>
            <strong>Event Starts:</strong> {getDateTimeString(new Date(draft.data.startDate))}
          </span>
        </div>
        <div className={styles.descriptionSection}>
          <div className={styles.descriptionLabel}>
            <strong>Description:</strong>
          </div>
          <p className={styles.description}>{draft.data.description}</p>
        </div>
        <div className={styles.infoRow}>
          <div className={styles.infoSection}>
            <h4>Minting Configuration</h4>
            <p>
              <strong>Supply:</strong> {draft.data.mintingConfiguration.supply}
            </p>
            <p>
              <strong>Blockchain:</strong> {getChainName(draft.data.mintingConfiguration.blockchainId)}
            </p>
          </div>
          <div className={styles.infoSection}>
            <DistributionInfo distribution={draft.data.distribution} draftData={draft.data} />
          </div>
        </div>
        <ReviewsSection draftId={draft.id} recentReviews={draft.recentReviews || []} />
        <ActionsMenu draft={draft} />
      </div>
      <AddCommentModal draft={draft} isOpen={showAddCommentModal} onClose={() => setShowAddCommentModal(false)} />
    </div>
  )
}

export default Card
